import module from 'fan/proyecto/module.js'
import template from './template.html'
import { orderBy } from 'lodash'
import * as moment from 'moment'

export class FanProyectoColaboradoresIDSEHistorialComponent {
  proyectoId = null
  promise
  fechaInicial = moment().startOf('month').toDate()
  fechaFinal = moment().endOf('month').toDate()

  constructor (FanProyectoColaboradoresIDSEHistorialService) {
    this.FanProyectoColaboradoresIDSEHistorialService = FanProyectoColaboradoresIDSEHistorialService
  }

  $onInit () {
    this.buscar()
  }

  buscar () {
    this.promise = this.FanProyectoColaboradoresIDSEHistorialService.get(this.proyectoId, this.fechaInicial, this.fechaFinal)
      .then(({data}) => (this.data = orderBy(data, ['fecha'], ['desc'])))
  }

  eliminar (eliminado) {
    this.data = this.data.filter((movimiento) => movimiento !== eliminado)
  }
}

module.component('fanProyectoColaboradoresIdseHistorial', {
  controller: FanProyectoColaboradoresIDSEHistorialComponent,
  template,
  bindings: {
    proyectoId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/idse/historial/component.js